import { render, staticRenderFns } from "./docResource.vue?vue&type=template&id=d5946316&"
import script from "./docResource.vue?vue&type=script&lang=js&"
export * from "./docResource.vue?vue&type=script&lang=js&"
import style0 from "./docResource.vue?vue&type=style&index=0&id=d5946316&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5946316')) {
      api.createRecord('d5946316', component.options)
    } else {
      api.reload('d5946316', component.options)
    }
    module.hot.accept("./docResource.vue?vue&type=template&id=d5946316&", function () {
      api.rerender('d5946316', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/resource/docResource.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/resource/docResource.vue
// module id = kdHj
// module chunks = 0